export default {
    document_click: [] as MouseEvent[],
    document_click_id: [] as string[],
    document_scroll: [] as MouseEvent[],
    document_scroll_id: [] as string[],
}
